<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="直播">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="header-back">
            <div class="header-search">
                <i class="iconfont">&#xe629;</i><input v-model="keyword" placeholder="试试搜商品/主播" @keyup.enter="confirm" />
            </div>
            <div v-if="gc_list" class="header-class">
                <div class="gc-item" :class="{'active':gc_id==0}" @click="setGoodsClassId(0)">全部</div>
                <div v-bind:key="gc.gc_id" v-for="gc in gc_list" :class="{'active':gc_id==gc.gc_id}" @click="setGoodsClassId(gc.gc_id)" class="gc-item">{{gc.gc_name}}</div>
            </div>
        </div>
        <div class="header-back2"></div>
        <div class="header-holder"></div>
        <div class="flex-wrapper" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="live-list" v-if="liveList && liveList.length">
                <div class="live-item" v-for='item in liveList' @click="goLiveDetail(item)" v-bind:key="config.live_type == 1?item.minipro_live_id:item.live_apply_id">
                    <div class="live-cover" v-if="config.live_type == 1">
                        <img :style="getBannerStyle" :src="item.minipro_live_image_url">
                    </div>
                    <div class="live-cover" v-else>
                        <video :style="getBannerStyle" v-if="item.live_apply_cover_video" :src="item.live_apply_cover_video_url" muted="muted" autoplay="autoplay" loop="loop" />
                        <img :style="getBannerStyle" v-else :src="item.live_apply_cover_image_url">
                    </div>
                    <div class="live-info">
                        <div class="live-name" v-if="config.live_type == 1">{{item.minipro_live_name}}</div>
                        <div class="live-name" v-else>{{item.live_apply_name}}</div>
                        <div class="store-info">
                            <div class="left">
                                <img class="store-avatar" :src="item.store_avatar">
                            </div>
                            <div class="right">
                                <div class="store-name">{{item.store_name}}</div>
                                <div class="area-info">{{item.area_info}}</div>
                            </div>
                        </div>
                        <div class="goods-list" v-if="item.goods_list">
                            <div class="goods-item goods-item-1">
                                <div class="goods-back" v-if="item.goods_list[0]">
                                    <img :src="item.goods_list[0].goods_image"/>
                                    <div class="goods-price">￥{{item.goods_list[0].goods_price}}</div>
                                </div>
                            </div>
                            <div class="goods-item goods-item-2">
                                <div class="goods-back" v-if="item.goods_list[1]">
                                    <img :src="item.goods_list[1].goods_image"/>
                                    <div v-if="item.goods_count<=2" class="goods-price">￥{{item.goods_list[1].goods_price}}</div>
                                    <div v-else class="goods-more">
                                        <div class="goods-text-list">
                                            <div class="goods-text">{{item.goods_count-1}}</div>
                                            <div class="goods-text">宝贝</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="goods-class" v-if="item.gc_name"><div class="goods-class-item">#{{item.gc_name}}</div></div>
                    </div>
                </div>
            </div>
            <empty-record v-if='liveList && !liveList.length'></empty-record>
        </div>
    </div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapActions } from 'vuex'
import { getLiveList, getMiniproLiveList } from '../../../api/memberLive'
import { loadScript } from '../../../util/common'
export default {
  name: 'LiveList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      gc_list: false,
      keyword: '',
      gc_id: this.$route.query.gc_id ? this.$route.query.gc_id : '', // 文章分类ID
      liveList: false,
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      inMinipro: 0
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    }),
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width / 2
      return {
        width: itemWidth + 'px',
        height: itemWidth + 'px'
      }
    }
  },
  created () {
    this.fetchConfig()
    let _this = this
    loadScript('weixin', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js', function () {
      _this.inMinipro = 2
    })
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    loadMore () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.getLiveList(true)
      }
    },
    setGoodsClassId (gc_id) {
      this.gc_id = gc_id
      this.reload()
    },
    confirm () {
      this.reload()
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.loading = false
      this.liveList = []
      this.loadMore()
    },
    getLiveList () {
      Indicator.open()
      if (this.config.live_type == 1) {
        getMiniproLiveList(Object.assign({ gc_id: this.gc_id, keyword: this.keyword }, this.params)).then(res => {
          Indicator.close()
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }

          if (this.liveList) {
            this.liveList = this.liveList.concat(res.result.minipro_live_list)
          } else {
            this.liveList = res.result.minipro_live_list
          }
          if (!this.gc_list) {
            this.gc_list = res.result.goodsclass_list
          }
        }).catch(error => {
          Indicator.close()
          Toast(error.message)
        })
      } else {
        getLiveList(Object.assign({ gc_id: this.gc_id, keyword: this.keyword }, this.params)).then(res => {
          Indicator.close()
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }

          if (this.liveList) {
            this.liveList = this.liveList.concat(res.result.live_apply_list)
          } else {
            this.liveList = res.result.live_apply_list
          }
          if (!this.gc_list) {
            this.gc_list = res.result.goodsclass_list
          }
        }).catch(error => {
          Indicator.close()
          Toast(error.message)
        })
      }
    },
    goLiveDetail (item) {
      if (this.config.live_type == 1) {
        if (this.inMinipro == 0) {
          Toast('环境加载中，请稍等')
          return
        }

        let _this = this
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            _this.inMinipro = 1
          }
        })
        if (this.inMinipro == 2) {
          Toast('请在小程序中打开')
          return
        }
        if (this.inMinipro == 1) {
          wx.miniProgram.navigateTo({ url: 'plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=' + item.minipro_live_room_id })
        }
      } else {
        this.$router.push({ 'name': 'MemberLiveDetail', 'query': { 'live_apply_id': item.live_apply_id } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .common-header-wrap .common-header{border-bottom: 0;background: $primaryColor;color:#fff;box-shadow: unset}
    .header-back2{
        height: 5rem;background:$primaryColor;position: fixed;z-index: 1;width: 100%;top:5rem;
    }
    .header-holder{height: 4.5rem;}
    .header-back{
        height: 4.5rem;
        background:$primaryColor;
        position: fixed;
        width: 100%;
        z-index: 3;
    }
    .header-search{margin:0 0.8rem;position: relative;
        input{width: 100%;height: 1.5rem;line-height: 1.5rem;background: rgba(255,255,255,.2);border-radius:1.5rem;text-indent: 1.5rem;border:0;color:#fff;font-size:$subFontSize;}
        input::-webkit-input-placeholder{color: #f7d8d8}
        i{position: absolute;color:#f7d8d8;display:block;width:1.5rem;line-height: 1.5rem;text-align: center;}
    }
    .header-class{position:relative;height:1.5rem;white-space: nowrap;overflow: hidden;overflow-x: auto;margin-top:.8rem;font-size:$subFontSize;color:#f7d8d8;padding:0 .4rem;
        .gc-item{display: inline-block;margin:0 .4rem;}
        .gc-item.active{color:#fff;position: relative;
            &::after{content:' ';position: absolute;bottom: -.4rem;width:1rem;height: 3px;background: #fff;border-radius: 3px;left:50%;margin-left:-.5rem;}
        }
    }
    .flex-wrapper{margin:0 .8rem;position: relative;z-index: 2;
        .live-item{border-radius:1rem;background: #fff;margin-bottom:.8rem;overflow:hidden;
            display: flex;
            .live-cover{
                background: #000;font-size: 0;
            }
            .live-info{flex:1;
                .live-name{padding:0 .4rem;font-size:$h2;margin:.8rem 0;font-weight: 700}
                .store-info{padding:0 .4rem;display: flex;
                    .store-avatar{width:1.5rem;height: 1.5rem;border-radius: 1.5rem}
                    .right{flex:1;
                        .store-name{font-size:$subFontSize;white-space: nowrap;overflow: hidden;text-overflow: ellipsis}
                        .area-info{font-size:$fontSize;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:#666}
                    }
                }
            }
            .goods-list{padding:0 .4rem;overflow: hidden}
            .goods-item{width:50%;height: 0;padding-bottom:50%;float: left;position: relative;
                .goods-back{position: absolute;top:0.2rem;left:0.2rem;right:0.2rem;bottom:0.2rem;border-radius: .2rem;overflow: hidden;
                    img{position: absolute;width:100%;height: 100%;}
                }
                .goods-price{position: absolute;bottom:0;let:.4rem;color:#fff;font-size:$subFontSize}
                .goods-more{width:100%;height: 100%;background: rgba(0,0,0,.5);font-size:$subFontSize;color:#fff;position: absolute;text-align: center}
                .goods-text{line-height: 1rem}
                .goods-text-list{position: relative;top:50%;margin-top:-1rem;}
            }
            .goods-item-1{}
            .goods-item-2{}
            .goods-class{padding:0 .4rem}
            .goods-class-item{font-size:$fontSize;line-height: 1rem;padding:0 .4rem;background: #fff2e2;display: inline-block;border-radius: .2rem;color:#ce7303}
        }
    }
</style>
